import Vue from 'vue'
import Router from 'vue-router'
import registration from '@/Registration.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'form',
      component: registration
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: registration
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js